import useStoreMetaOfferWhenLanding from "../../hooks/useStoreLandingMetaOffer.js";
import React, { Profiler, useContext } from "react";
import { useLocation, useParams } from "react-router-dom";
import { metaPreOptedAncillariesFromFlightDetailsScreenQueryToApiQuery } from "../../utils/preOptedAncillaries.js";
import AppShell from "../../components/elements/AppShell/index.js";
import { FlightDetailsInnerNewMobile } from "../../components/elements/FlightDetailsInner/index.js";
import { POSMisMatch } from "../../components/elements/POSMisMatch/index.js";
import { useClientFetch } from "../../hooks/useClientFetch.js";
import useTrackFlightDetailsPriceChangeGoal from "../../hooks/useTrackFlightDetailsPriceChangeGoal.js";
import StaticContext from "../../app/StaticContext/StaticContext.js";
import useReportPriceDiscrepancy from "../../hooks/useReportPriceDiscrepancy.js";
import useRemoveExternalParamsFromUrl from "../../hooks/useRemoveExternalParamsFromUrl.js";
import useLogFORAPErrors from "../../hooks/useLogFORAPErrors.js";
import useTrackFlightDetailsBrandedFaresGoals from "../../hooks/useTrackFlightDetailsBrandedFaresGoals.js";
import useKayakS2SParams from "../../hooks/useKayakS2SParams.js";
import useProfiler from "../../hooks/useProfiler.js";
import { WishlistWidgetLoaderMobile } from "../../components/remote/index.js";
import { HelmetHeader, useFlightDetailsMobileController, useFlightDetailsMobileApiUrl, useFlightDetailsMobileEffects } from "./index.js";
import { useSelector } from "react-redux";
import { getFlightDetailsFetchStatus } from "../../store/flightDetails/selectors.js";
import useTrackDeltaFlightDetailsGoal from "../../hooks/useTrackDeltaFlightDetailsGoal.js";
import { FlightsFunnelNewFdPageMobileTracker } from "../../utils/experiments/funnel/flights_funnel_new_fd_page_mobile.js";
import useFlightDetailsAbortApiCallWeb from "./useFlightDetailsAbortApiCallWeb.js";
import { useSIRFTrackFlightDetails } from "../../hooks/useSIRFMessageTracking.js";
export default function FlightDetailsNewMobile(props) {
    const location = useLocation();
    const { getInitialState } = props;
    const { isLoggedInAuthLow } = useProfiler();
    const staticContext = useContext(StaticContext);
    const params = useParams();
    const fetchStatus = useSelector(getFlightDetailsFetchStatus);
    const urlParams = new URLSearchParams(location.search);
    const queryParams = new URLSearchParams(location.search);
    const searchParams = metaPreOptedAncillariesFromFlightDetailsScreenQueryToApiQuery(urlParams);
    const landingOfferFromMeta = useStoreMetaOfferWhenLanding(params?.id);
    const { flight, posMismatch, backToSearch, onFetch, onFetchAbort, onFetchSuccess, onFetchError, trackRenderTime, hasPrefetchedBrandedFareOffers } = useFlightDetailsMobileController(params, landingOfferFromMeta);
    useSIRFTrackFlightDetails(flight);
    const { generateApiUrl } = useFlightDetailsMobileApiUrl(params);
    if (getInitialState && staticContext.set) {
        staticContext.set({ getInitialState: getInitialState(queryParams) });
    }
    useFlightDetailsMobileEffects(params, queryParams, urlParams);
    useRemoveExternalParamsFromUrl();
    useTrackFlightDetailsPriceChangeGoal();
    useTrackFlightDetailsBrandedFaresGoals();
    useLogFORAPErrors(params.id);
    useReportPriceDiscrepancy(params.id);
    useKayakS2SParams(fetchStatus, flight, landingOfferFromMeta, searchParams, params);
    useTrackDeltaFlightDetailsGoal(flight);
    const url = generateApiUrl(urlParams, searchParams);
    const { signal, isAbortError } = useFlightDetailsAbortApiCallWeb(url);
    useClientFetch(url, {
        signal,
        fetch: onFetch,
        success: onFetchSuccess,
        error: (err) => {
            const e = err;
            if (isAbortError(err)) {
                onFetchAbort();
                return;
            }
            onFetchError(e);
        }
    });
    return (React.createElement(Profiler, { id: "screen", onRender: trackRenderTime },
        React.createElement(HelmetHeader, null),
        React.createElement(AppShell, { noPadding: true },
            fetchStatus === "success" && posMismatch && (React.createElement(POSMisMatch, { goToSearch: backToSearch, POSMismatch: posMismatch })),
            (fetchStatus === "loading" || fetchStatus === "failed" || (flight && !posMismatch)) && (React.createElement(FlightDetailsInnerNewMobile, { flight: flight, flightToken: params?.id, fetchStatus: fetchStatus, onClose: backToSearch, hasPrefetchedBrandedFareOffers: hasPrefetchedBrandedFareOffers })),
            flight ? React.createElement(FlightsFunnelNewFdPageMobileTracker, { flight: flight }) : undefined,
            isLoggedInAuthLow() ? React.createElement(WishlistWidgetLoaderMobile, null) : null)));
}
